import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { checkWin } from ".";
var pageMetaMap = {};
var getLowcodePageDevInfoFromDom = function() {
    var devInfo = {};
    if (!checkWin()) {
        return devInfo;
    }
    var _window_siteInfo = window.siteInfo, siteInfo = _window_siteInfo === void 0 ? {} : _window_siteInfo;
    var dom = document.getElementById("mod-cn-cone-page-level");
    if (dom) {
        if (siteInfo.appCode) {
            devInfo.appCode = siteInfo.appCode;
        }
        var pageMetaData = dom.getAttribute("data-lowcode-page-meta") || "";
        try {
            var pageMeta = JSON.parse(decodeURIComponent(pageMetaData));
            if (pageMeta) {
                var keyList = [
                    "lowCodeAppCode",
                    "lowCodePageId",
                    "pageType",
                    "pageVersionId",
                    "templateId"
                ];
                var keyMap = {
                    lowCodeAppCode: "appCode",
                    lowCodePageId: "pageId",
                    pageType: "pageSubtype"
                };
                for(var index = 0; index < keyList.length; index += 1){
                    var key = keyList[index];
                    // @ts-ignore 无需理会
                    var metaValue = pageMeta[key] || pageMeta[keyMap[key]];
                    if (metaValue) {
                        // @ts-ignore 无需理会
                        devInfo[key] = metaValue;
                    }
                }
            }
        } catch (error) {
        // do nothing
        }
    }
    return devInfo;
};
var isWallePage = function() {
    if (checkWin()) {
        if (typeof window.walle === "object" && window.walle) {
            var _window_walle_walleRouter_walleRouterComp, _window_walle_walleRouter, _window_walle_walleRouter_walleRouterComp1, _window_walle_walleRouter1;
            var routeType = (_window_walle_walleRouter = window.walle.walleRouter) === null || _window_walle_walleRouter === void 0 ? void 0 : (_window_walle_walleRouter_walleRouterComp = _window_walle_walleRouter.walleRouterComp) === null || _window_walle_walleRouter_walleRouterComp === void 0 ? void 0 : _window_walle_walleRouter_walleRouterComp.routeType;
            var currentPagePath = (_window_walle_walleRouter1 = window.walle.walleRouter) === null || _window_walle_walleRouter1 === void 0 ? void 0 : (_window_walle_walleRouter_walleRouterComp1 = _window_walle_walleRouter1.walleRouterComp) === null || _window_walle_walleRouter_walleRouterComp1 === void 0 ? void 0 : _window_walle_walleRouter_walleRouterComp1.pagePath;
            return routeType === "browserHistory" && location.pathname.indexOf(currentPagePath) > -1 || routeType === "hashHistory" && typeof location.hash === "string" && location.hash && location.hash.indexOf(currentPagePath) > -1;
        }
    }
    return false;
};
var isToffeePage = function() {
    if (checkWin()) {
        var _window_Toffee_config, _window_Toffee;
        if (typeof window.Toffee === "object" && typeof ((_window_Toffee = window.Toffee) === null || _window_Toffee === void 0 ? void 0 : (_window_Toffee_config = _window_Toffee.config) === null || _window_Toffee_config === void 0 ? void 0 : _window_Toffee_config.getConfig) === "function") {
            var routeType = (window.Toffee.config.getConfig() || {}).routeType;
            var _ref = window.Toffee.toffeeRoutes || {}, _ref_routeMap = _ref.routeMap, routeMap = _ref_routeMap === void 0 ? {} : _ref_routeMap;
            return routeType === "browserHistory" && location.pathname in routeMap || routeType === "hashHistory" && typeof location.hash === "string" && location.hash.substring(1) in routeMap;
        }
    }
    return false;
};
export var getConeDevInfo = function() {
    var spaRouteType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (checkWin()) {
        var _conePageMetaData;
        var sourceCodeMetaData = window.CONE_PAGE_META;
        var conePageMetaData = window.currentPageConfig;
        var _window_siteInfo = window.siteInfo, siteInfo = _window_siteInfo === void 0 ? {} : _window_siteInfo, location1 = window.location;
        var coneDevInfo = {};
        var mapKey = location1.pathname;
        var lowCodePageInfo = getLowcodePageDevInfoFromDom();
        var isLowCodePage = ((_conePageMetaData = conePageMetaData) === null || _conePageMetaData === void 0 ? void 0 : _conePageMetaData.type) === "ebcPage" || lowCodePageInfo.lowCodePageId;
        if (spaRouteType === "hash") {
            mapKey = "".concat(location1.pathname).concat(location1.hash);
        }
        if (sourceCodeMetaData && typeof sourceCodeMetaData === "object" && !isLowCodePage) {
            var group = sourceCodeMetaData.group, project = sourceCodeMetaData.project, page = sourceCodeMetaData.page, path = sourceCodeMetaData.path, hash = sourceCodeMetaData.hash;
            if (path === location1.pathname && (spaRouteType !== "hash" || hash === location1.hash)) {
                // 将metaData缓存起来，避免单页应用切换路由再切回来时，metaData丢失
                pageMetaMap[mapKey] = sourceCodeMetaData;
                coneDevInfo = {
                    group: group,
                    project: project,
                    pageSrcPath: page
                };
            }
        }
        if (Object.keys(coneDevInfo).length === 0 && typeof pageMetaMap[mapKey] === "object" && !isLowCodePage) {
            coneDevInfo = {
                group: pageMetaMap[mapKey].group,
                project: pageMetaMap[mapKey].project,
                pageSrcPath: pageMetaMap[mapKey].page
            };
        }
        if (conePageMetaData && typeof conePageMetaData === "object" && (!conePageMetaData.path || conePageMetaData.path === location1.pathname)) {
            var lowCodeAppCode = conePageMetaData.lowCodeAppCode, id = conePageMetaData.id, url = conePageMetaData.url, lowCodeCurrentSubPageId = conePageMetaData.lowCodeCurrentSubPageId, lowCodeCurrentSubPageType = conePageMetaData.lowCodeCurrentSubPageType;
            var appCode = siteInfo.appCode;
            Object.assign(coneDevInfo, lowCodePageInfo);
            if (appCode) {
                coneDevInfo.appCode = appCode;
            }
            if (id) {
                coneDevInfo.menuId = id;
            }
            if (lowCodeAppCode) {
                coneDevInfo.lowCodeAppCode = lowCodeAppCode;
            }
            if (lowCodeCurrentSubPageType && !coneDevInfo.pageType) {
                coneDevInfo.pageType = lowCodeCurrentSubPageType;
            }
            if (lowCodeCurrentSubPageId) {
                coneDevInfo.lowCodePageId = lowCodeCurrentSubPageId;
            } else if (lowCodeAppCode && Array.isArray(url) && url.length > 0) {
                var pageSourceUrl = url.find(function(str) {
                    return str.indexOf(lowCodeAppCode) > -1;
                });
                if (pageSourceUrl) {
                    var matchInfo = pageSourceUrl.match(new RegExp("".concat(lowCodeAppCode, "/(\\d+?)/")));
                    if (matchInfo && matchInfo.length > 1) {
                        coneDevInfo = _object_spread_props(_object_spread({}, coneDevInfo), {
                            lowCodePageId: matchInfo[1]
                        });
                    }
                }
            }
        } else if (isLowCodePage && Object.keys(lowCodePageInfo).length > 0) {
            coneDevInfo = _object_spread({}, coneDevInfo, lowCodePageInfo);
        }
        if (isWallePage()) {
            coneDevInfo.isWallePage = "Y";
        }
        if (isToffeePage()) {
            coneDevInfo.isToffeePage = "Y";
        }
        if (Object.keys(coneDevInfo).length > 0) {
            return coneDevInfo;
        }
    }
    return undefined;
};

 //# sourceMappingURL=dev-info.js.map